import { useState } from 'react';
import { Box, ListItem, UnorderedList } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from '../../../ui-components';

export const ReviewGuideLines = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <Box>
            <Button variant="text-button-no-hover" onClick={() => setIsOpen(!isOpen)}>
                <FormattedMessage
                    id="turn-to.review-modal.review-guidelines"
                    defaultMessage="Review guidelines"
                />
            </Button>
            {isOpen && (
                <Box marginY={4}>
                    <Text size="small">
                        <FormattedMessage
                            id="turn-to.review-modal.guidelines"
                            defaultMessage="We value your input and invite you to rate and review your purchases. Be sure to explain why you like or dislike the product and focus on the product's features and your own experience using it."
                        />
                    </Text>
                    <Text size="small">
                        <FormattedMessage
                            id="turn-to.review-modal.guidelines-2"
                            defaultMessage="If you wish to comment about product selection, pricing, ordering, delivery or other issues, please contact our customer support."
                        />
                    </Text>
                    <Text size="small">
                        <FormattedMessage
                            id="turn-to.review-modal.guidelines-3"
                            defaultMessage="Please refrain from including any of the following in your review:"
                        />
                    </Text>
                    <UnorderedList>
                        <ListItem>
                            <Text size="small">
                                <FormattedMessage
                                    id="turn-to.review-modal.guidelines-list-1"
                                    defaultMessage="Obscene or discriminatory language"
                                />
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text size="small">
                                <FormattedMessage
                                    id="turn-to.review-modal.guidelines-list-2"
                                    defaultMessage="Critical or inappropriate comments about other reviews and shoppers"
                                />
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text size="small">
                                <FormattedMessage
                                    id="turn-to.review-modal.guidelines-list-3"
                                    defaultMessage="Advertising, spam, references to other websites or retailers"
                                />
                            </Text>
                        </ListItem>
                        <ListItem>
                            <Text size="small">
                                <FormattedMessage
                                    id="turn-to.review-modal.guidelines-list-4"
                                    defaultMessage="Personal information such as email addresses, phone numbers or physical addresses"
                                />
                            </Text>
                        </ListItem>
                    </UnorderedList>
                    <Text size="small">
                        <FormattedMessage
                            id="turn-to.review-modal.guidelines-4"
                            defaultMessage="All reviews are subject to our store's Terms of Use."
                        />
                    </Text>
                </Box>
            )}
        </Box>
    );
};
